<template lang="html">

	<section class="login-view column-center" :style="`background:url(${background}) center/cover no-repeat; background-size:cover`">
	<div class="container-login" :style="style.bgbody" >
		
		<div class="popup column-center contenedor-login-terceros">
			<img :src="logo" class="logo">

			<div class="contenedor-input" v-if="passuser != pass & !!!status">
				<label for="">Introduce la contraseña</label>
				<input type="text" :style="style.input_black" v-model="passuser">
			</div>

			<template v-if="passuser == pass | status">
				<p>Estado: {{(status) ? 'Activo' : 'Inactivo'}}</p>
				<div class="contenedor-botones row-center">
					<a class="btn" :style="style.solidPrimary" @click="activarGodMode">Activar</a>
					<a class="btn" :style="style.skull_primary" @click="desactivarGodMode">Desactivar</a>
				</div>
				<router-link class="btn login" :style="style.solidPrimary" to="/login">Ir al login</router-link>
			</template>
		</div>
	</div>
	</section>

</template>

<script lang="js">

	import {mapGetters,mapActions} from 'vuex';

	export default  {
		name: 'modo-dios',
		data(){
			return{
				pass : 'passgma2019',
				passuser : ''
			}
		},
		computed:{
			...mapGetters({
				background : 'getBackground',
				logo : 'getLogoColor',
				style : 'getStyles',
				status : 'getGodmodeStatus'
			})
		},
		methods :{
			...mapActions(['desactivarGodMode','activarGodMode'])
		}

	}
</script>

<style scoped lang="scss">
	.popup{
		width: 700px;
		padding: 50px;
		background: white;

		.logo{
			max-width: 200px;
			margin-bottom: 30px;
			display: inline-block;
		}

		h2{
			width: 100%;
			display: inline-block;
			margin-bottom: 10px;
		}
	}

	.btn:first-of-type{
		margin-right: 20px;
	}

	.btn.login{
		margin-top: 20px;
	}

	#loginImgAdicional{
		height: 100%;
		width: 100%;
		position: absolute;
		background: linear-gradient(90deg, rgba(49,234,193,1) 0%, rgba(212,249,151,1) 100%);
		z-index: -1;
	}

</style>



// WEBPACK FOOTER //
// src/components/views/god-mode.vue